


<header class="container">
  <div class="toolbar" [class.opened]="opened">
    <div class="left">
      <!-- DESKTOP. La barra llevaba las DOS versiones y escondía una con una media query de
           992 px: 14 nodos por página construidos para no verse nunca, y de paso dos
           enlaces "MiChollo - Inicio" para un lector de pantalla. El umbral de `esMovil()`
           es ese mismo (993), y la media query se quita: dejarla además del `@if` deja la
           cabecera vacía cuando el User-Agent y el ancho no coinciden. -->
      @if (!isMobile) {
        <a class="invisible" href="/" appGoToUrl aria-label="MiChollo - Inicio">
          <img class="logo" src="/assets/images/logo.svg" alt="Michollo" title="logo" width="205" height="29">
        </a>

        <!-- «☰ Menú» de la cabecera V26 (S5): abre el mismo menú que el antiguo selector «Inicio». -->
        <button type="button" class="menu26 mc-btn" aria-haspopup="true" [attr.aria-expanded]="opened" (click)="openMenuPopover($event)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
          Menú
        </button>
      }
      <!-- END DESKTOP -->

      <!-- MOBILE: sólo el logo a la izquierda (31/10/2026: «en la barra de arriba el logo y la de
           buscar»). El menú ☰ y el avatar salen de aquí: secciones, ajustes y sesión están en
           la fila de secciones y en la pantalla Cuenta de la barra inferior. -->
      @if (isMobile) {
        <a class="invisible" href="/" appGoToUrl aria-label="MiChollo - Inicio">
          <img class="logo_mobile" src="/assets/images/logo.svg" alt="MiChollo" title="logo" width="110" height="15">
        </a>
      }
      <!-- END MOBILE -->
    </div>

  <div class="center">
    @if (!isMobile) {
      <div class="searchBar" role="search">
        <app-search></app-search>
      </div>
    } @else {
      <!-- Buscador móvil en la barra: el campo abre el panel de búsqueda de siempre y el
           micrófono la ventana de voz (app-boton-voz se oculta solo si el navegador no tiene voz). -->
      <div class="buscador_cabecera" role="search">
        <button type="button" class="buscador_cabecera__campo mc-btn" aria-label="Buscar" [attr.aria-expanded]="searchIsOpen" (click)="openSearch($event)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
          <span>Buscar chollos…</span>
        </button>
        <app-boton-voz></app-boton-voz>
      </div>
    }
  </div>

  <div class="right">
    <!-- Bajo 993 px la zona derecha va vacía: «Sube tu chollo», alertas, perfil y sesión están en
         la barra inferior y en su pantalla Cuenta (31/10/2026). -->
    @if (!isMobile) {
      <!-- Alertas / Mensajes / Guardados de la V26: icono con el texto debajo. Con sesión abren
           los mismos paneles de antes, anclados a este contenedor (#openMenuButton); sin sesión,
           igual que «Sube tu chollo», abren el acceso. Salen SIEMPRE, con sesión o sin ella
           (dueño, 02/11/2026: «eso debería salir siempre»): nada de `solo-sesion26`, que los
           escondía sin sesión. -->
      <nav #openMenuButton aria-label="Tu cuenta" class="cuenta26" (click)="openMenuButtons($event)">
        <button type="button" class="ic26 alerts mc-btn" (pointerenter)="precargarAlertas()" (focus)="precargarAlertas()" [attr.aria-label]="user() && notificationCount ? 'Alertas, ' + notificationCount + ' sin leer' : null" (click)="$event.stopPropagation(); user() ? openAlertPopover() : openAuthModal();">
          <span class="ic26__icono">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
            @if (user() && notificationCount) {
              <span class="ic26__globo" aria-hidden="true">{{ notificationBadge }}</span>
            }
          </span>
          Alertas
        </button>
        <button type="button" class="ic26 messages mc-btn" (click)="$event.stopPropagation(); user() ? openMessagePopover() : openAuthModal();">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>
          Mensajes
        </button>
        <button type="button" class="ic26 deals_saved mc-btn" (click)="$event.stopPropagation(); user() ? openSavedDealsPopover() : openAuthModal();">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
          Guardados
        </button>
      </nav>

      <button type="button" class="share_chollo global_button mc-btn" (click)="user() ? uploadPopover($event) : openAuthModal()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" aria-hidden="true" style="pointer-events: none;"><path d="M12 5v14M5 12h14"/></svg>
        <span class="text" style="pointer-events: none;">Sube tu chollo</span>
      </button>
    }

    @if (!user() && !isMobile) {
      <button type="button" aria-label="Regístrate / Inicia sesión" class="share_chollo global_button mc-btn" [class.acceso26]="!isMobile" (click)="openAuthModal()">
        <span class="icon" style="pointer-events: none;">
          <svg appIcon src="/assets/icons/new_design/person.svg"></svg>
        </span>
        <div class="text" style="pointer-events: none;">
          Regístrate / Inicia sesión
        </div>
      </button>
    }

    @if (user() && !isMobile) {
      <app-user [user]="user()" [link]="false" [statitics]="false" (click)="openUserToolPanel($event)"></app-user>
    }

    <!--
      Marcador de posición de la zona de usuario (incidente 13/09/2026). El HTML del SSR
      es el mismo para todos: siempre anónimo. Desde el 12/09 a quien tiene sesión se le
      esconde «Regístrate/Inicia sesión», y hasta que Angular hidrataba se quedaba un
      HUECO donde va su avatar. Esto es la MISMA zona, en estático: como no depende de
      `user` ni de nada del navegador, servidor y cliente pintan lo mismo y la hidratación
      no se entera (nada de nodos metidos a mano, nada de NG05xx). Se ve sólo con la marca
      `mc-con-sesion` del body y desaparece en cuanto existe <app-user> (regla hermana de
      toolbar.component.scss) o cuando app.component.ts retira la marca —sesión revocada,
      que no llega a pintar avatar—. La foto sale de la variable --mc-avatar que publica
      el script de index.html leyendo `mc-0-user`. `aria-hidden` + `tabindex=-1` porque no
      es interactivo: es la foto fija de lo que va a haber ahí.
    -->
    @if (!isMobile) {
      <div class="sesion_previa" aria-hidden="true">
        <div class="avatar theme-bg theme-border-color theme-chollo-user">
          <div class="foto"></div>
        </div>
      </div>
    }
  </div>
</div>

<!-- Fila 2 de la cabecera V26 (S5): secciones. La fila 3 (orden) va en app-user-toolbar, que es
     quien tiene las pestañas y los filtros de cada listado. -->
@if (!isMobile) {
  <app-cabecera-secciones class="fila26" [url]="url()"></app-cabecera-secciones>
}

<!-- Anclaje del menú móvil. El <ng-container> se queda vacío hasta que `montarMenu()` crea el
     componente en el primer hueco de inactividad, así que el SSR y el primer render no pintan
     nada: no engorda el HTML de ninguna página y no hay desajuste de hidratación posible.
     A partir de ahí, abrir es sólo la clase `abierto`.

     `menu_movil__fuera` es una capa transparente a pantalla completa por detrás del panel:
     cierra al pulsar fuera, igual que el backdrop invisible del popover, y sin escuchas en
     document. El Escape se ata aquí para que el enlace no exista antes de estar montado. -->
@if (isMobile) {
  <div class="menu_movil" [class.abierto]="opened" (document:keydown.escape)="cerrarMenu()">
    <div class="menu_movil__fuera" (click)="cerrarMenu()" aria-hidden="true"></div>
    <div class="menu_movil__panel">
      <ng-container #anclaMenu></ng-container>
    </div>
  </div>

  <!-- Buscador móvil en línea, mismo planteamiento que el menú. Aquí basta un `@if` porque
       SearchComponent ya vive en ShellModule; sigue montándose sólo tras el idle para no
       añadir sus ~72 nodos al HTML de todas las páginas. -->
  @if (buscadorMontado) {
    <div class="buscador_movil" [class.abierto]="searchIsOpen" (document:keydown.escape)="cerrarBuscador()">
      <div class="buscador_movil__fuera" (click)="cerrarBuscador()" aria-hidden="true"></div>
      <div class="buscador_movil__panel">
        <app-search [mobile]="true" (cerrar)="cerrarBuscador()"></app-search>
      </div>
    </div>
  }
}
</header>

<!-- Lo que el anfitrión proyecta debajo de la cabecera (la franja del 11.11): así forma parte de la
     barra fija (z 10) y no queda detrás de las páginas. -->
<ng-content></ng-content>
